//import if needed
//export if needed


//put accessors here or import them from another file


export {getScenarioFeedback} from "./mergeDataFiles"
export {colorTypes,iconTypes, fbTemplatesDef } from "./c1Data"
export {phaseStatusList, leafStatusList} from "./c2Data"
export {aggregateLabels, intvChecks, scenarioConstraintIDs, conditionalConstraints, globalConstraints, 
    exceptionDefs, vitalsCheckFeedbackLabel, vitalsCheckFeedbackID, intvPromptResponsesWhereCorrectnessMatters} from "./analysisData"
export {SC8CP_PhaseIE} from "./SC8CP_data_PhaseIE"
export {B4CA_PhaseIE} from "./B4CA_data_PhaseIE"
export {B5CA_PhaseIE} from "./B5CA_data_PhaseIE"
export {C5CA_PhaseIE} from "./C5CA_data_PhaseIE"
export {M2CA_PhaseIE} from "./Bogus data for testingA"
